import { http } from '../../../axios';
import { localContentPrefix } from '../../../../config';

const url = `${localContentPrefix}/v1/localcontent/keywords`;
export const fetchKeywordSuggestions = (input = '') => {
    return http.get<string[]>(url, { params: { q: input } }).then(response => response.data);
};
